// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"FooterCard_footerContainer__1mwNl"};